import { MappingPluginId } from "@models/service";

/**
 * Which result-table layout a job renders. Decoupled from the raw plugin id
 * so new plugins can be mapped to a layout in one place (the dictionary below)
 * without touching render code.
 */
export const ResultTableVariant = {
  TechnicalManual: "technical-manual",
  Wd: "wd-mapping",
  Default: "default",
} as const;
export type ResultTableVariant =
  (typeof ResultTableVariant)[keyof typeof ResultTableVariant];

const VARIANT_BY_PLUGIN_ID: Readonly<Record<string, ResultTableVariant>> = {
  [MappingPluginId.TechnicalManual]: ResultTableVariant.TechnicalManual,
  [MappingPluginId.WdMapping]: ResultTableVariant.Wd,
};

/** Resolves a plugin id to its table variant, falling back to the default
 * (generic) layout for unknown / missing ids. */
export const resolveResultTableVariant = (
  pluginId: string | null | undefined,
): ResultTableVariant =>
  (pluginId ? VARIANT_BY_PLUGIN_ID[pluginId] : undefined) ??
  ResultTableVariant.Default;
